export default __webpack_public_path__ + "static/media/photo--sm--97.7e847261.jpg";